import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UsersService } from '../users.service';
import { LoaderService } from 'src/app/loader/loader.service';

import { environment } from '../../../environments/environment';
import { User } from '../models/user';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Perfil } from '../models/perfil';
import * as moment from 'moment';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
  selector: 'app-users-details',
  templateUrl: './users-details.component.html',
  styleUrls: ['./users-details.component.scss'],
})
export class UsersDetailsComponent implements OnInit {
  env;
  user: User;
  profiles: Perfil[];

  dropdownList = [];
  dropdownSettings: IDropdownSettings = {};

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private usersService: UsersService,
    private loaderService: LoaderService,
    private permissionsService: PermissionsService
  ) {
    this.env = environment;
  }

  async ngOnInit() {
    this.setCompaniesDropdown();
    await this.handlePermissionsToGetPerfis();

    this.getUser(this.route.snapshot.paramMap.get('uid'));
  }

  async getUser(uid: string) {
    const loader = await this.loaderService.notifica({
      title: 'Buscando usuário...',
      date: moment().toISOString(),
      type: 'loading',
    });

    this.user = await this.usersService.getUser(uid).toPromise();

    this.filterCompaniesByUserPermissions();

    loader.dismiss();
  }

  private async handlePermissionsToGetPerfis() {
    const profiles = await this.usersService.getPerfis().toPromise();

    if (!this.permissionsService.isProfile('Master')) {
      this.profiles = profiles.filter(profile => profile.nome !== 'Master');
    } else {
      this.profiles = profiles;
    }
  }

  private filterCompaniesByUserPermissions() {
    this.user.empresas = this.user.empresas.filter(company => {
      for (let userCompany of this.env.user.empresas) {
        if (company.cnpj === userCompany.cnpj) {
          return true;
        }
      }
      return false;
    });
  }

  setCompaniesDropdown() {
    this.dropdownList = this.env.user.empresas;

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'cnpj',
      textField: 'fantasia',
      selectAllText: 'Selecionar Todos',
      unSelectAllText: 'Deselecionar Todos',
      itemsShowLimit: 4,
      allowSearchFilter: true,
      searchPlaceholderText: 'Pesquisar',
    };
  }

  compareByName(itemOne, itemTwo) {
    return itemOne && itemTwo && itemOne.nome === itemTwo.nome;
  }

  goBack(): void {
    this.router.navigateByUrl(`/users/${this.env.selected.cnpj}`);
  }
}
